import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import { uploadFile as uploadApi } from '@/components/upload/upload';
import { searchWinBidSupplier } from '../../../api';
import { createOtherSupplierRow, normalizeCustomerId } from './utils/taskData';
import formHelpers, { getProjectInfoStatus } from './utils/form';
import SectionEditActions from './SectionEditActions';
export default {
  name: 'ProjectKickoffTab',
  components: {
    UploadFile: UploadFile,
    SectionEditActions: SectionEditActions
  },
  mixins: [formHelpers],
  inject: {
    elForm: {
      default: null
    }
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    projectStatus: {
      type: [String, Number],
      default: null
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    leaderOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    quotationCheckboxDisabled: {
      type: Boolean,
      default: false
    },
    quotationCheckboxLabel: {
      type: String,
      default: '报价单'
    },
    customerName: {
      type: String,
      default: ''
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    },
    shouldShowTaskType: {
      type: Function,
      required: true
    }
  },
  computed: {
    meetingMinutesImageSrcList: function meetingMinutesImageSrcList() {
      var _this$formData$projec,
        _this = this;
      return (((_this$formData$projec = this.formData.project_meeting) === null || _this$formData$projec === void 0 ? void 0 : _this$formData$projec.meeting_minutes_file) || []).filter(function (item) {
        return _this.isImageFile(item);
      }).map(function (item) {
        return _this.$ossurl + item.url;
      });
    }
  },
  methods: {
    projectInfoStatus: function projectInfoStatus() {
      return getProjectInfoStatus(this.projectStatus, this.formData);
    },
    showProjectLeader: function showProjectLeader() {
      return [100, 200, 399, 400, 600].includes(this.projectInfoStatus());
    },
    isProjectInfoLimitedStatus: function isProjectInfoLimitedStatus() {
      return ![1, 100, 500, 600].includes(this.projectInfoStatus());
    },
    isProjectInfoFieldDisabled: function isProjectInfoFieldDisabled(field) {
      return this.type === 'view' && this.isEditingTask('projectInfo') && this.isProjectInfoLimitedStatus() && ['is_bidding', 'process_result'].includes(field);
    },
    isProjectInfoTaskDisabled: function isProjectInfoTaskDisabled() {
      return this.type === 'view' && this.isEditingTask('projectInfo');
    },
    changeIsBidding: function changeIsBidding(val) {
      var _this2 = this;
      this.formData.project_evaluation.need_bid_writing = '';
      this.formData.project_evaluation.want_cooperate_bid_dept = '';
      this.formData.project_evaluation.registration_company_entity = '';
      if (val !== '1') {
        this.formData.project_evaluation.purchase_content = [];
        this.formData.project_evaluation.history_competitor_info = '';
        this.formData.project_evaluation.history_discount_info = '';
        this.formData.project_evaluation.history_delivery_form = '';
        this.formData.project_meeting.bid_opening_method = '';
        this.formData.project_meeting.bid_send_time = '';
      } else if (this.type != 'add') {
        if (this.formData.type.indexOf('2') === -1) {
          this.formData.type.push('2');
        }
      }
      this.$nextTick(function () {
        _this2.elForm && _this2.elForm.clearValidate(['project_evaluation.need_bid_writing', 'project_evaluation.want_cooperate_bid_dept', 'project_evaluation.purchase_content', 'project_meeting.bid_opening_method', 'project_meeting.bid_send_time']);
      });
    },
    changeNeedBidWriting: function changeNeedBidWriting(val) {
      var _this3 = this;
      this.formData.project_evaluation.want_cooperate_bid_dept = '';
      this.$nextTick(function () {
        _this3.elForm && _this3.elForm.clearValidate('project_evaluation.want_cooperate_bid_dept');
      });
    },
    changeProcessResult: function changeProcessResult(val) {
      var _this4 = this;
      if (val != '1') {
        var abandonReason = val === '3' ? this.formData.project_meeting.abandon_reason || '' : '';
        this.formData.project_meeting = {
          process_result: val,
          customer_relationship: '',
          purchase_count: undefined,
          per_capita_budget: undefined,
          purchase_amount: '',
          bid_opening_method: '',
          bid_send_time: '',
          bid_opening_time: '',
          need_sample: '',
          sample_deadline: '',
          demo_type: '',
          quotation_type: '',
          settlement_method: '',
          report_type: '',
          meeting_minutes: '',
          meeting_minutes_file: [],
          abandon_reason: abandonReason,
          bid_strategy_resources: '',
          history_order_director: '',
          quotation: '',
          other_suppliers: [createOtherSupplierRow()]
        };
      } else {
        this.formData.project_meeting.purchase_count = this.formData.customers_num || undefined;
        this.formData.project_meeting.per_capita_budget = this.formData.per_capita_budget || undefined;
        this.calcPurchaseAmount();
        if (this.formData.project_evaluation.is_bidding === '1' && this.formData.type.indexOf('2') === -1) {
          this.formData.type.push('2');
        }
      }
      this.$nextTick(function () {
        _this4.elForm && _this4.elForm.clearValidate(['person_charge_id', 'project_meeting.customer_relationship', 'project_meeting.purchase_count', 'project_meeting.per_capita_budget', 'project_meeting.bid_opening_method', 'project_meeting.bid_send_time', 'project_meeting.bid_opening_time', 'project_meeting.need_sample', 'project_meeting.sample_deadline', 'project_meeting.demo_type', 'project_meeting.quotation_type', 'project_meeting.settlement_method', 'project_meeting.report_type', 'project_meeting.bid_strategy_resources']);
      });
    },
    changeNeedSample: function changeNeedSample(val) {
      var _this5 = this;
      if (val !== '2') {
        this.formData.project_meeting.sample_deadline = '';
      }
      this.$nextTick(function () {
        _this5.elForm && _this5.elForm.clearValidate('project_meeting.sample_deadline');
      });
    },
    calcPurchaseAmount: function calcPurchaseAmount() {
      var count = parseFloat(this.formData.project_meeting.purchase_count) || 0;
      var budget = parseFloat(this.formData.project_meeting.per_capita_budget) || 0;
      this.formData.project_meeting.purchase_amount = count && budget ? (count * budget).toFixed(2) : '';
    },
    handleProjectFileUploaded: function handleProjectFileUploaded(key, url, fileName, uid) {
      var fileItem = {
        file_name: fileName,
        url: key
      };
      this.formData.project_evaluation.project_files.push(fileItem);
      this.elForm && this.elForm.validateField('project_evaluation.project_files');
    },
    handleMeetingMinutesFileUploaded: function handleMeetingMinutesFileUploaded(key, url, fileName) {
      var list = this.formData.project_meeting.meeting_minutes_file;
      if (list.length >= 9) {
        this.$message.warning('会议纪要附件最多上传9个');
        return;
      }
      list.push({
        file_name: fileName,
        url: key
      });
    },
    uploadMeetingMinutesFile: function uploadMeetingMinutesFile() {
      this.$refs.meetingMinutesUpload.uploadBanner();
    },
    deleteMeetingMinutesFile: function deleteMeetingMinutesFile(index) {
      this.formData.project_meeting.meeting_minutes_file.splice(index, 1);
    },
    handleMeetingMinutesPaste: function handleMeetingMinutesPaste(event) {
      var list = this.formData.project_meeting.meeting_minutes_file;
      if (list.length >= 9) {
        this.$message.warning('会议纪要附件最多上传9个');
        return;
      }
      var _iterator = _createForOfIteratorHelper(event.clipboardData.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (item.type.indexOf('image') === -1) continue;
          var file = item.getAsFile();
          if (file) this.uploadMeetingMinutesFromPaste(file);
          break;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    },
    uploadMeetingMinutesFromPaste: function uploadMeetingMinutesFromPaste(file) {
      var _this6 = this;
      if (file.size / 1024 / 1024 > 300) {
        this.$message.error('请上传300M以内的文件');
        return;
      }
      var loading = this.$loading({
        lock: true,
        text: '上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      uploadApi(file, null, {
        config: '/user/project-delivery-file/upload/config'
      }).then(function (response) {
        if (response.status !== 200) {
          _this6.$message.error('上传失败');
          return;
        }
        _this6.handleMeetingMinutesFileUploaded(response.config.key, '', file.name);
      }).catch(function () {
        _this6.$message.error('上传失败');
      }).finally(function () {
        loading.close();
      });
    },
    deleteProjectFile: function deleteProjectFile(index) {
      var _this7 = this;
      this.formData.project_evaluation.project_files.splice(index, 1);
      this.$nextTick(function () {
        _this7.elForm && _this7.elForm.validateField('project_evaluation.project_files');
      });
    },
    handleViewHistoryOrder: function handleViewHistoryOrder() {
      var company_name = this.customerName;
      var route = this.$router.resolve('/platformReport/orderConsumeStatistics?customer_id=' + this.formData.customer_id + '&company_name=' + company_name + '&delivery=1');
      window.open(route.href, '_blank');
    },
    addOtherSupplier: function addOtherSupplier() {
      this.formData.project_meeting.other_suppliers.push(createOtherSupplierRow());
    },
    // 成交供应商远程搜索：结果替换选项列表，已选中项补回保证回显
    searchSupplierOptions: function searchSupplierOptions(keyword, supplier) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, list, selectedId;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return searchWinBidSupplier({
                keyword: (keyword || '').trim()
              });
            case 1:
              res = _context.v;
              list = (res.data || []).map(function (item) {
                return {
                  id: String(item.id),
                  company_name: item.company_name
                };
              });
              selectedId = normalizeCustomerId(supplier.customer_id);
              if (selectedId && !list.some(function (item) {
                return item.id === selectedId;
              })) {
                list.unshift({
                  id: selectedId,
                  company_name: supplier.company_name
                });
              }
              supplier.options = list;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    // 选中时同步供应商名称；清空时一并清掉，避免旧名称继续参与提交
    changeSupplierOption: function changeSupplierOption(supplier, id) {
      var option = (supplier.options || []).find(function (item) {
        return item.id === id;
      });
      supplier.company_name = option ? option.company_name : '';
    },
    // 展开时按空关键字刷新默认列表，避免只剩已选项或上次搜索结果
    handleSupplierVisible: function handleSupplierVisible(visible, supplier) {
      if (visible) {
        this.searchSupplierOptions('', supplier);
      }
    },
    removeOtherSupplier: function removeOtherSupplier(index) {
      this.formData.project_meeting.other_suppliers.splice(index, 1);
    }
  }
};